import api from "./api";

const url = "/admin/database";

const databaseApi = {
    getAllTables: () => api.get(`${url}/tables`),
    getTableColumns: (tableName) => api.get(`${url}/tables/${tableName}/columns`),
    getAllStoredProcedures: () => api.get(`${url}/stored-procedures`),
    getStoredProcedure: (procedureName) => api.get(`${url}/stored-procedures/${procedureName}`),
    executeQuery: (sqlQuery) => api.post(`${url}/execute-query`, { sqlQuery }),
    executeNonQuery: (sqlQuery) => api.post(`${url}/execute-non-query`, { sqlQuery }),
    getProtectedTables: () => api.get(`${url}/protected-tables`),
    updateProtectedTables: (tables) => api.post(`${url}/update-protected-tables`, { tables }),
    getAllDatabases: () => api.get(`${url}/all`),
    getTablesByDatabase: (databaseName) => api.get(`${url}/tables-by-db?databaseName=${databaseName}`),
    getDatabaseTableSizes: (databaseName) => api.get(`${url}/${databaseName}/tables`),
    getDatabaseObjects: (databaseName) => api.get(`${url}/${databaseName}/objects`),
    getTableDependencies: (databaseName, tableName) => api.get(`${url}/${databaseName}/tables/${tableName}/dependencies`),
    cloneSchema: (sourceDb, targetDb, jobId) => api.post(`${url}/clone-schema`, { SourceDatabase: sourceDb, TargetDatabase: targetDb, JobId: jobId }),
    getCloneProgress: (jobId) => api.get(`${url}/clone-progress/${jobId}`),
    transferData: (sourceDb, targetDb, tableName) => api.post(`${url}/transfer-data`, { SourceDatabase: sourceDb, TargetDatabase: targetDb, TableName: tableName }),
    transferObject: (sourceDb, targetDb, objectName, objectType, transferMode, keepIdentity) => api.post(`${url}/transfer-object`, { SourceDatabase: sourceDb, TargetDatabase: targetDb, ObjectName: objectName, ObjectType: objectType, TransferMode: transferMode, KeepIdentity: keepIdentity }),
    deleteDatabase: (databaseName, password) => api.post(`${url}/delete`, { DatabaseName: databaseName, Password: password }),
    compareObject: (sourceDb, targetDb, objectName, objectType) => api.get(`${url}/compare-object?sourceDb=${sourceDb}&targetDb=${targetDb}&objectName=${objectName}&objectType=${objectType}`),
};

export default databaseApi;

